"use strict";
/**
 *
 * Copyright 2020-2025 Splunk Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplunkSpanAttributesProcessor = void 0;
const user_tracking_1 = require("./user-tracking");
const session_1 = require("./session");
class SplunkSpanAttributesProcessor {
    constructor(globalAttributes, useLocalStorageForSessionMetadata, getUserTracking, domain) {
        this.useLocalStorageForSessionMetadata = useLocalStorageForSessionMetadata;
        this.getUserTracking = getUserTracking;
        this.domain = domain;
        this._globalAttributes = globalAttributes !== null && globalAttributes !== void 0 ? globalAttributes : {};
    }
    forceFlush() {
        return Promise.resolve();
    }
    getGlobalAttributes() {
        return this._globalAttributes;
    }
    onEnd() {
        // Intentionally empty
    }
    onStart(span) {
        // now that we have started the span, the session is not inactive anymore
        const sessionState = (0, session_1.updateSessionStatus)({ forceStore: false, inactive: false });
        span.setAttribute('location.href', location.href);
        span.setAttributes(this._globalAttributes);
        span.setAttribute('splunk.rumSessionId', sessionState.id);
        if (this.getUserTracking() === 'anonymousTracking') {
            span.setAttribute('user.anonymousId', (0, user_tracking_1.getOrCreateAnonymousId)({
                useLocalStorage: this.useLocalStorageForSessionMetadata,
                domain: this.domain,
            }));
        }
        span.setAttribute('browser.instance.visibility_state', document.visibilityState);
    }
    setGlobalAttributes(attributes) {
        if (attributes) {
            Object.assign(this._globalAttributes, attributes);
        }
        else {
            for (const key of Object.keys(this._globalAttributes)) {
                delete this._globalAttributes[key];
            }
        }
    }
    shutdown() {
        (0, user_tracking_1.forgetAnonymousId)();
        return Promise.resolve();
    }
}
exports.SplunkSpanAttributesProcessor = SplunkSpanAttributesProcessor;
//# sourceMappingURL=SplunkSpanAttributesProcessor.js.map